export default {
  "nl": {
    "select": {
      "actions": {
        "clear": "Verwijderen",
        "filterProject": "Filter op Project",
        "filterUnit": "Filter op Unit",
        "noResults": "Geen resultaten",
        "noResultsFor": "Geen resultaten voor {search}",
        "reset": "Reset",
        "selectCategory": "Selecteer Categorie",
        "setToday": "Vandaag",
        "startTyping": "Typ om verder te zoeken"
      },
      "groups": {
        "customers": "Klanten",
        "employees": "Teamleden"
      },
      "labels": {
        "allUnits": "Alle units",
        "contact": "Contactpersoon"
      }
    }
  }
}